import styles from "./styles.module.css";
import { useEffect, useContext, useState, useRef, useCallback } from "react";
import Header from "../header";
import { PageValue } from "../../../contexts/page";
import { AppValue, AppDisbatch } from "../../../contexts/app";
import DND from "./dndhandler";
import Render from "./render";
import { useParams } from "react-router-dom";
import Errors from "./errors";

export default function Paper({ editor, setWorkflows, setUtilities }) {
  const [width, setWidth] = useState(1200);
  const [height, setHeight] = useState(400);
  const [zoom, setZoom] = useState(100);
  const pageRef = useRef();
  const tree = useContext(PageValue);
  const { components } = useContext(AppValue);
  const appDisbatch = useContext(AppDisbatch);
  const start = useRef(0);
  const { type, pageId } = useParams();

  useEffect(() => {
    if (type === "components") {
      const comp = components.find((x) => x.id === pageId);
      if (comp.width) {
        setWidth(comp.width);
      }
      if (comp.height) {
        setHeight(comp.height);
      }
    }
  }, [type, pageId]);

  const handleWidth = (value) => {
    if (type === "components") {
      const comp = components.find((x) => x.id === pageId);
      if (comp) {
        appDisbatch({
          type: "updateComponent",
          component: { id: comp.id, key: "width", value },
        });
      }
    }
    setWidth(value);
  };

  const handleHeight = (value) => {
    if (type === "components") {
      const comp = components.find((x) => x.id === pageId);
      if (comp) {
        appDisbatch({
          type: "updateComponent",
          component: { id: comp.id, key: "height", value },
        });
      }
    }
    setHeight(value);
  };

  useEffect(() => {
    const handleWheel = (e) => {
      if (e.ctrlKey) {
        e.preventDefault();
        // Your zoom/scale factor
        let handle = zoom - e.deltaY * 0.5;
        if (handle < 10) {
          setZoom(10);
        } else if (handle > 200) {
          setZoom(200);
        } else {
          setZoom(Math.round((handle + Number.EPSILON) * 100) / 100);
        }
      }
    };
    window.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      window.removeEventListener("wheel", handleWheel);
    };
  }, [zoom]);

  if (!tree) {
    return <div style={{ flexGrow: 1 }} />;
  }
  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        overflow: "auto",
      }}
    >
      <Header
        width={{ value: width, set: handleWidth }}
        height={{ value: height, set: handleHeight }}
        zoom={{ value: zoom, set: setZoom }}
        editor={editor}
      />
      <div
        ref={pageRef}
        //onWheel={handleWheel}
        id={styles.scrollBox}
      >
        <div
          style={{
            width: (width * zoom) / 100 + 80,
            minWidth: (width * zoom) / 100 + 80,
            marginBottom: 40,
            marginLeft: "auto",
            marginRight: "auto",
            padding: 40,
            paddingTop: 0,
          }}
        >
          <div
            id="PAPERCANVAS"
            className={styles.paper}
            style={{
              width: width,
              height: type === "components" ? height : "unset",
              transform: `scale(${zoom ? zoom / 100 : 1})`,
              transformOrigin: "top left",
            }}
          >
            <DND
              accept={["component", "overlay"]}
              block={tree}
              path={[]}
              index={0}
            >
              <Render />
            </DND>
          </div>
        </div>
      </div>
      <Errors />
    </div>
  );
}
